<template>
  <div
    v-if="isShow.companyImages"
    class="clearfix fs13 plr20 pt30 pb30 tc row-last"
    :style="`background: url(${userImageUrlForPc}/top/bg_01.png) repeat left;`"
    data-test="images"
  >
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="topic"
      :comment-highlights="commentHighlights"
      text-count-class="topic"
      :text-counts="textCounts"
      v-on="$listeners"
    />
    <template v-for="index in [1,2,3]">
      <figure
        v-if="companyInfo[`companyImage${index}Caption`]"
        :key="`image-${index}`"
      >
        <img
          v-if="companyInfo[`companyImage${index}`].id"
          :id="`${targetIdMap.companyInfo.images.image}-${index}`"
          :src="getPhotoUrl(companyInfo[`companyImage${index}`])"
          class="company-img-sub"
          :data-test="`image-${index}`"
          @load="$emit('onLoadImage')"
          @error="$emit('onLoadImage')"
        >
        <figcaption
          :id="`${targetIdMap.companyInfo.images.caption}-${index}`"
          class="tl fs12 mt15"
          :data-test="`image-${index}-caption`"
          v-text="companyInfo[`companyImage${index}Caption`]"
        />
      </figure>
    </template>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    JobPreviewRightColumn
  },
  mixins: [jobPreviewCommon],
  props: {
    highlightMode: {
      type: Boolean,
      default: false
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    textCountMode: {
      type: Boolean,
      default: false
    },
    textCounts: {
      type: Array,
      default: () => []
    },
    companyInfo: {
      type: Object,
      required: true
    }
  }
}
</script>
